import {Grid} from '@yandex-delivery/blocks'
import clsx from 'clsx'
import React from 'react'

import {FooterApp, FooterAppProps} from '../components/footer-app/FooterApp@desktop'
import {FooterLogoDesktop, FooterLogoProps} from '../components/footer-logo/FooterLogo@desktop'
import {footerClasses} from './Footer@desktop.classes'

type FooterProps = {
  footerLogo: FooterLogoProps
  footerApp: FooterAppProps
  legal?: React.ReactNode
  storeDisclaimers?: React.ReactNode
  footerIcons: React.ReactNode
  legalLinks: React.ReactNode
  navLinkList: React.ReactNode
  seoHeading: React.ReactNode
}

export function Footer({
  footerLogo,
  footerApp,
  legal,
  storeDisclaimers,
  footerIcons,
  navLinkList,
  legalLinks,
  seoHeading,
}: FooterProps): React.ReactElement {
  return (
    <footer className={footerClasses.root} id="footer">
      <div className={footerClasses.footerContainer}>
        <Grid className={footerClasses.firstLine} justify="space-between" wrap="nowrap" container>
          <Grid className={footerClasses.logoContainer} item>
            <FooterLogoDesktop {...footerLogo} />
          </Grid>
          <Grid className={footerClasses.appContainer} item>
            <FooterApp qr={footerApp.qr} stores={footerApp.stores} />
          </Grid>
        </Grid>
        <div className={footerClasses.separator} />

        <Grid direction="column" container>
          <Grid className={footerClasses.navigation} item>
            {navLinkList}
          </Grid>
          <Grid item>{seoHeading}</Grid>
          <Grid className={clsx(footerClasses.legal, footerClasses.caption1)} direction="column" container item>
            <Grid item>{legal}</Grid>
            <Grid item>{storeDisclaimers}</Grid>
          </Grid>

          <Grid className={footerClasses.legalLinks} wrap="nowrap" container item>
            {legalLinks}
          </Grid>

          <Grid justify="space-between" wrap="nowrap" container item>
            {footerIcons}
          </Grid>
        </Grid>
      </div>
    </footer>
  )
}
